import { render } from "./EditSources.vue?vue&type=template&id=dafd54ce&scoped=true"
import script from "./EditSources.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSources.vue?vue&type=script&setup=true&lang=js"

import "./EditSources.vue?vue&type=style&index=0&id=dafd54ce&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dafd54ce"],['__file',"resources/js/modules/product-mapping-tool/components/EditSources.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dafd54ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dafd54ce', __exports__)) {
    api.reload('dafd54ce', __exports__)
  }
  
  module.hot.accept("./EditSources.vue?vue&type=template&id=dafd54ce&scoped=true", () => {
    api.rerender('dafd54ce', render)
  })

}


export default __exports__